import React from "react";
import ReactEcharts from "echarts-for-react";
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import withRouter from "../../components/Common/withRouter"

const GamePie = (props) => {
  let data = props.data
  
  let chartdata = [
    { value: 0, name: props.t("Bowling") },
    { value: 0, name: props.t("Billiard") },
    { value: 0, name: props.t("Carrom") },
    { value: 0, name: props.t("Card") },
    { value: 0, name: props.t("Snooker VIP") },
    { value: 0, name: props.t("Snooker") },
    { value: 0, name: props.t("Table Tennis") },
    { value: 0, name: props.t("PC Steering Wheel") },
    { value: 0, name: props.t("Diamond Billiard") },
    { value: 0, name: props.t("PC") },
    { value: 0, name: props.t("Play Station 5") },
    { value: 0, name: props.t("Foosball") },
    { value: 0, name: props.t("VIP Room") },
    { value: 0, name: props.t("VIP Room Extension") },
    

  ];
  if (data) {
    chartdata = [
      { name: props.t("Bowling"), value: data.bowling },
      { name: props.t("Billiard"), value: data.billiard },
      { name: props.t("Carrom"), value: data.carrom },
      { name: props.t("Card"), value: data.card },
      { name: props.t("Snooker VIP"), value: data.snooker_vip },
      { name: props.t("Snooker"), value: data.snooker },
      { name: props.t("Table Tennis"), value: data.table_tennis },
      { name: props.t("PC Steering Wheel"), value: data.pc_steering_wheel },
      { name: props.t("Diamond Billiard"), value: data.diamond_billiard },
      { name: props.t("PC"), value: data.pc },
      { name: props.t("Play Station 5"), value: data.play_station_5 },
      { name: props.t("Foosball"), value: data.foosball },
      { name: props.t("VIP Room"), value: data.vip_room },
      { name: props.t("VIP Room Extension"), value: data.vip_room_extension },

    ];
  }
  const options = {
    toolbox: {
      show: false,
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    legend: {
      orient: "vertical",
      left: "left",
      data: [
        props.t("Bowling"),
        props.t("Billiard"),
        props.t("Carrom"),
        props.t("Card"),
        props.t("Snooker VIP"),
        props.t("Snooker"),
        props.t("Table Tennis"),
        props.t("PC Steering Wheel"),
        props.t("Diamond Billiard"),
        props.t("PC"),
        props.t("Play Station 5"),
        props.t("Foosball"),
        props.t("VIP Room"),
        props.t("VIP Room Extension"),
    
      ],
      textStyle: {
        color: ["#8791af"],
      },
    },
    color: ["#FF5733", "#3366FF", "#FFCC33", "#66FF99", "#33567F", "#33FFCC", "#9595DC","#33FF66", "#CC33FF", "#E77C29" ,"#0B9AA2","#A78B45"],
    series: [
      {
        name: props.name,
        type: "pie",
        radius: "55%",
        center: ["60%", "60%"],
        data: chartdata,          
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };
  return (
    <React.Fragment>
      <ReactEcharts style={{ height: "350px" }} option={options} />
    </React.Fragment>
  );
};
export default withRouter(connect(null, {})(withTranslation()(GamePie)));
